<template>
  <b-row>

    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>

    <b-col md="12">

      <b-card header="signature_provider">

        <b-row>
          <b-col md="12">
            <b-card :header="'Logs'">
              <b-col><h5>Último Log Recebido: <b>{{lastLogReceived | dateFormat}}</b></h5></b-col>
            </b-card> 
          </b-col>
        </b-row>
        
        <b-row>
          <b-col md="12">
            <b-card :header="'Assinaturas'">
              <graph-line
                :height="400"
                :shape="'normal'"
                :axis-min="0"
                :axis-max="signatureMax * 10"
                :axis-full-mode="true"
                :labels="signatureDates"
                :names="signatureNames"
                :values="signatureValues">
                  <tooltip :names="signatureNames" :position="'right'"></tooltip>
                  <legends :names="signatureNames"></legends>
                  <guideline :tooltip-y="true"></guideline>
              </graph-line>
            </b-card> 
          </b-col>
        </b-row>

        

        <b-row>
          <b-col md="6">
            <b-card :header="'Memory (' + memoryUn + ')'">
              <graph-line
                :height="400"
                :shape="'normal'"
                :axis-min="0"
                :axis-max="memoryTotal"
                :axis-full-mode="true"
                :labels="memoryDates"
                :names="memoryNames"
                :values="memoryValues">
                  <tooltip :names="memoryNames" :position="'right'"></tooltip>
                  <legends :names="memoryNames"></legends>
                  <guideline :tooltip-y="true"></guideline>
              </graph-line>
            </b-card> 
          </b-col>
          <b-col md="6">
            <b-card :header="'Memory Swap (' + memoryUn + ')'">
                <graph-line
                  :height="400"
                  :shape="'normal'"
                  :axis-min="0"
                  :axis-max="swapTotal"
                  :axis-full-mode="true"
                  :labels="swapDates"
                  :names="swapNames"
                  :values="swapValues">
                    <tooltip :names="swapNames" :position="'right'"></tooltip>
                    <legends :names="swapNames"></legends>
                    <guideline :tooltip-y="true"></guideline>
                </graph-line>
              </b-card> 
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-card :header="'Disk (' + diskUn + ')'">
              <graph-line
                :height="400"
                :shape="'normal'"
                :axis-min="0"
                :axis-max="diskTotal"
                :axis-full-mode="true"
                :labels="diskDates"
                :names="diskNames"
                :values="diskValues">
                  <tooltip :names="diskNames" :position="'right'"></tooltip>
                  <legends :names="diskNames"></legends>
                  <guideline :tooltip-y="true"></guideline>
              </graph-line>
            </b-card>
          </b-col>
          <b-col md="6">
            <b-card :header="'Processes'">
              <graph-line
                :height="400"
                :shape="'normal'"
                :axis-min="0"
                :axis-max="processesMax * 2"
                :axis-full-mode="true"
                :labels="diskDates"
                :names="['processes']"
                :values="processesValues">
                  <tooltip :names="['processes']" :position="'right'"></tooltip>
                  <legends :names="['processes']"></legends>
                  <guideline :tooltip-y="true"></guideline>
              </graph-line>
            </b-card>
          </b-col>
        </b-row>


        <b-row>
          <b-col md="12">
            <b-card :header="'CPU Information'">
              <b-row>
                <b-col><h5>numbers_cpu: <b>{{num_cpu}}</b></h5></b-col>
                <b-col><h5>cpu_usage: <b>{{cpu_usage}}</b></h5></b-col>
                <b-col><h5>proc_loadavg: <b>{{proc_loadavg}}</b></h5></b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        
        <b-row>
          <b-col md="12">
            <b-card :header="'Cess'">
              <b-row>
                <b-col><h5>Last Average Cess: <b>{{averageCess.last_average}}</b></h5></b-col>
                <b-col><h5>Bigger Request Cess: <b>{{averageCess.bigger_request}}</b></h5></b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        
        <b-row>
          <b-col md="12">
            <b-card :header="'Cloud'">
              <b-row>
                <b-col><h5>Last Average Cloud: <b>{{averageCloud.last_average}}</b></h5></b-col>
                <b-col><h5>Bigger Request Cloud: <b>{{averageCloud.bigger_request}}</b></h5></b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>

      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env, formatDate } from '@/shared/utils';
import _ from 'underscore';
import { mapActions } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import LineExample from '../charts/LineExample'
import PieExample from '../charts/PieExample'

export default {
  name: 'Monitor',
  components: {
    Loading,
    LineExample,
    PieExample
  },
  props: {
    caption: {
      type: String,
      default: 'Monitor'
    },
  },
  data: () => {
    return {
        loadCount: 0,
        memoryData: [],
        objListMonitor: [],

        swapValues: [],
        swapNames: [],
        swapDates: [],
        swapTotal: '',
        swapUn: '',

        diskValues: [],
        diskNames: [],
        diskDates: [],
        diskTotal: [],
        diskUn: '',

        signatureValues: [],
        signatureNames: [],
        signatureDates: [],

        memoryValues: [],
        memoryNames: [],
        memoryDates: [],
        memoryTotal: '',
        memoryUn: '',
        averageCloud: {
          last_average: '',
          bigger_request: ''
        },
        averageCess: {
          last_average: '',
          bigger_request: ''
        },
        signatureMax: 0,
        processesValues: [],
        processesMax: 0,
        num_cpu: '',
        cpu_usage: '',
        proc_loadavg: '',



        

        labels: [ new Date("2018-07-07 00:00:00"), new Date("2018-07-08 00:00:00") ],
        names: [ "MS", "Apple", "Google" ],
        values: [
            [ 10, 0, 5, 5 ],
            [ 40, 10, 10, 10 ],
            [ 30, 25, 35, 30 ]
        ]
    }
  },
  mounted() {
      this.getMonitoring();
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    }
  },
  methods: {
    getMonitoring(){
      const self = this;
      this.loadCount++;
      // const loader = self.$loading.show();
      axios
        .get(`${env.urlBillingApi}/cess-monitoring?client_id=${self.$route.params.id}&limit=10`)
        .then(function(response) {
          self.objListMonitor = response.data.status;

          
          self.num_cpu = self.objListMonitor[self.objListMonitor.length - 1].num_cpu;
          self.cpu_usage = self.objListMonitor[self.objListMonitor.length - 1].cpu_usage;
          self.proc_loadavg = self.objListMonitor[self.objListMonitor.length - 1].proc_loadavg;
          // <b-col><h5>numbers_cpu: <b>{{objListMonitor[0].num_cpu}}</b></h5></b-col>
        //         <b-col><h5>cpu_usage: <b>{{objListMonitor[0].cpu_usage}}</b></h5></b-col>
        //         <b-col><h5>proc_loadavg: <b>{{objListMonitor[0].proc_loadavg}}</b></h5></b-col>



          self.lastLogReceived = response.data.last;
          self.swapNames = response.data.swap.names;
          self.swapValues = response.data.swap.values;
          self.swapDates = response.data.swap.date;
          self.swapTotal = response.data.swap.total;
          self.swapUn = response.data.swap.un;

          self.diskNames = response.data.disk.names;
          self.diskValues = response.data.disk.values;
          self.diskDates = response.data.disk.date;
          self.diskTotal = response.data.disk.total;
          self.diskUn = response.data.disk.un;
          
          if (response.data.status[0].average !== null && response.data.status[0].average !== undefined) {
            self.averageCloud = response.data.status[0].average.cloud_request;
            self.averageCess = response.data.status[0].average.cess_request;
          } else {
            self.averageCloud.last_average = 'Não Informado';
            self.averageCess.last_average = 'Não Informado';
            self.averageCloud.bigger_request = 'Não Informado';
            self.averageCess.bigger_request = 'Não Informado';
          }

          self.memoryNames = response.data.memory.names;
          self.memoryValues = response.data.memory.values;
          self.memoryDates = response.data.memory.date;
          self.memoryTotal = response.data.memory.total;
          self.memoryUn = response.data.memory.un;

          self.processesValues = response.data.processes;
          
          if (response.data.processes[0][0] === 0) {
            self.processesMax = 30;
          } else{
            self.processesMax = response.data.processes[0][0];;
          }
          

          self.signatureNames = response.data.signatures.names;
          self.signatureValues = response.data.signatures.values;


          if (response.data.signatures.values[0][0] === 0) {
            self.signatureMax = 30;
          } else{
            self.signatureMax = response.data.signatures.values[0][0];
          }

          self.signatureDates = response.data.signatures.date;
        })
        .catch(function(error) {
          self.$toasted.error(error.response.data.detail, {
            theme: "toasted-primary",
            position: "top-right",
            duration: 5000
          });
        })
        .finally(function() {
          self.loadCount--;
        });
    }
  },
  filters: {
    dateFormat: function(value) {
      if (!value) return '';
      let data = new Date(value);
      let dia  = data.getDate().toString(),
      diaF = (dia.length == 1) ? '0'+dia : dia,
      mes  = (data.getMonth()+1).toString(),
      mesF = (mes.length == 1) ? '0'+mes : mes,
      anoF = data.getFullYear(),
      hora = data.getHours().toString(),
      horaF = (hora.length == 1) ? '0'+hora : hora,
      min = data.getMinutes().toString(),
      minF = (min.length == 1) ? '0'+min : min,
      sec = data.getSeconds().toString(),
      secF = (sec.length == 1) ? '0'+sec : sec;
      return diaF+"/"+mesF+"/"+anoF+" "+horaF+":"+minF+":"+secF;
    }
  }
}
</script>

<style scoped>
@media (min-width: 576px) {
  .card-body >>> .card-list {
    max-width: 200px;
  }
}
</style>